<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <img class="img" :src="cardUserImage" />
    </div>

    <md-card-content>
      <h6 class="category text-gray">{{user.city}}</h6>
      <h4 class="card-title">{{user.outletName}}</h4>

      <p class="card-description text-center">
        {{user.description}}
        <br>
        <br>

        Open from {{user.startTime}} to {{user.endTime}}

        <br>
        <br>

        Address : {{user.address}} {{user.zip}} {{user.city}}
        Contact : {{user.primaryContact}}

      </p>
      <br><br>
      <p>
      </p>

      <p>

      </p>

      <md-button class="md-round purp" @click="update()">Update</md-button>

    </md-card-content>
  </md-card>
</template>
<script>
  import firebase from '../../Firebase';
export default {
  name: "user-card",
  props: {
    user:{
        type:Object
    },
    cardUserImage: {
      type: String,
      default: require("@/assets/img/vue-logo.png")
    }
  },
  data() {
    return {};
  },methods : {
      update(){
         firebase.firestore().collection("sellers").doc(this.user.uid).update(
             {'setup' : 0}). then( result => console.log(result));
      }
    }
};
</script>
<style>
.purp {
  background-color: purple;
}
</style>
